/**
 * Created by hernanherreros on 2019-05-09
 */

import * as yup from 'yup'
import { Field } from 'react-trazo-forms/dist/FormField'
import { messages } from '../../helpers/forms'

import { i18n } from '../../providers/Locale/localeProvider'
import { utils } from 'react-trazo-forms'

export const activationInitialValues = (activation?: any) => ({
  FirstName: activation ? activation['FirstName'] : '',
  LastName: activation ? activation['LastName'] : '',
  Email: activation ? activation['Email'] : '',
})



export const activationFields = (): Field[] => ([
  { name: 'FirstName', placeholder: 'Ej: Marcelo', label: i18n._('Nombre'), type: 'text', maxLength:15, parser: utils.parser.removeNonAlphaNumeric },
  { name: 'LastName', placeholder: 'Ej: Jara', label: i18n._('Apellido'), type: 'text', maxLength:15, parser: utils.parser.removeNonAlphaNumeric },
  { name: 'Email', placeholder: 'Ej: marcelo@example.com', label: i18n._('Correo Electrónico Principal'), type: 'text' },
])

export const activationValidationSchema = yup.object().shape({
  FirstName: yup.string()
    .required(messages.required),
  LastName: yup.string()
    .required(messages.required),
  Email: yup.string()
    .email(messages.email)
    .required(messages.required),
})
